/**
 * A single-file picker in the kit's look: a "Choose" button over a hidden
 * native input, the chosen file's name, and a clear button. Styles live with
 * its first user (theme/features/legal.css, `.file-pick`).
 */
import { useId, useRef } from 'react'
import { IconUpload, IconX } from '@tabler/icons-react'

export function FileInput({ value, onChange, accept, label, placeholder = 'Choose a file', disabled }: {
  value: File | null
  onChange: (file: File | null) => void
  accept?: string
  label: string
  placeholder?: string
  disabled?: boolean
}) {
  const id = useId()
  const input = useRef<HTMLInputElement>(null)
  return (
    <div className="fld">
      <label className="fld-label" htmlFor={id}>{label}</label>
      <div className={['file-pick', disabled ? 'is-disabled' : ''].join(' ')}>
        <input ref={input} id={id} type="file" className="sr-only" accept={accept} disabled={disabled} onChange={event => { onChange(event.target.files?.[0] ?? null); event.target.value = '' }} />
        <button type="button" className="btn is-small" disabled={disabled} onClick={() => input.current?.click()}><IconUpload className="ic-sm" aria-hidden="true" />{value ? 'Change' : 'Choose'}</button>
        <span className={value ? 'file-name' : 'file-name is-empty'} title={value?.name}>{value?.name ?? placeholder}</span>
        {value ? <button type="button" className="file-clear" aria-label={`Clear ${label}`} disabled={disabled} onClick={() => onChange(null)}><IconX className="ic-sm" /></button> : null}
      </div>
    </div>
  )
}
